import React, { useState, useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import { IconButton, Table, TableCell, TableRow } from '@mui/material'
import {
  arrowDown,
  arrowUp,
  fire,
  IconFire,
  IconRightArrowTable,
} from '../../../assets/images/icons'
import { Loader, NoDataFound } from '../../../components'
import ImageIcon from '../imageIcon'
import { checkLocalStorageSize, dateDifference, timeStampToDate, getImageUrl } from '../../../util'

import {
  TableBodyWrapper,
  TableCellHead,
  TableHeadWrapper,
  TableOuterWrapper,
  DateWrapper,
} from './style'

const Row = ({ row, getRowDetailDataFunc }) => {
  const openDetails = () => {
    getRowDetailDataFunc({ projectId: row.ProjectId })
  }

  return (
    <>
      {/* {showLoaderData && <PreLoadReportsData data={showLoaderData} page='projects' />} */}
      <TableRow onClick={openDetails} className={`tr_heading tr_${row.isVisible}`} id={`projectId__${row.BrandName.replaceAll(' ', '_')}`}>
        <TableCell style={{ position: 'relative', width: '65px' }}>
          <ImageIcon row={row} />
        </TableCell>
        <TableCell>{row.BrandName}</TableCell>
        <TableCell>{row.ProjectType}</TableCell>
        <TableCell>{row.MarketName}</TableCell>
        <TableCell>
          <DateWrapper>
            {timeStampToDate(row.ModifiedDate)}{' '}
            {dateDifference(row.ModifiedDate) <= 10 && <IconFire />}
          </DateWrapper>
        </TableCell>
        <TableCell className='showProjectDetails' sx={{ position: 'relative' }}>
          <IconButton aria-label='expand row' size='small'>
            <IconRightArrowTable />
          </IconButton>
        </TableCell>
      </TableRow>
    </>
  )
}

Row.propTypes = {
  row: PropTypes.object,
  getRowDetailDataFunc: PropTypes.func,
  loadingDetails: PropTypes.bool,
}

const DataGridTable = (props) => {
  const { columns, rows, loading, getRowDetailData } = props

  const [sortedRowData, setSortedRowData] = useState([])
  const [columnData, setColumnData] = useState(columns)
  // const [sortBy, setSortBy] = useState('')

  const sortArray = (key) => {
    const selectedKey = columnData.find((c) => c.sortKey === key)
    const selectedSorting = () => {
      if (selectedKey.sort === null) return true
      if (selectedKey.sort) return false
      if (!selectedKey.sort) return null
    }

    const compare = (a, b) => {
      if (a[key] < b[key]) {
        return -1
      }
      if (a[key] > b[key]) {
        return 1
      }
      return 0
    }

    if (selectedSorting() === null) {
      // setSortBy('')
      setSortedRowData(rows)
    } else {
      // setSortBy(key)
      // const d = sortedRowData.sort(compare)
      if (selectedSorting()) {
        setSortedRowData(sortedRowData.sort(compare))
      } else {
        setSortedRowData(sortedRowData.reverse())
      }
    }

    const updatingColumnData = columnData.map((c) => {
      c.sort = c.sortKey === key ? selectedSorting() : null
      return c
    })
    setColumnData(updatingColumnData)
  }

  const getRowDetailDataFunc = (param) => {
    getRowDetailData(param)
  }

  useEffect(() => {
    setSortedRowData([...rows])
    checkLocalStorageSize()
  }, [rows])

  return (
    <TableOuterWrapper>
      {loading && <Loader />}
      {!loading && (
        <Table id='ProjectListTable'>
          <TableHeadWrapper>
            <TableRow>
              {columnData.map((c, i) => (
                <TableCellHead key={i} onClick={() => sortArray(c.sortKey)} width={c.width}>
                  {c.field}
                  {c.sort !== null && <img src={c.sort ? arrowUp : arrowDown} alt='' />}
                </TableCellHead>
              ))}
              <TableCell width='50px' />
            </TableRow>
          </TableHeadWrapper>
          <TableBodyWrapper>
            {sortedRowData.length === 0 && (
              <TableRow>
                <TableCell colSpan={columnData.length + 1}>
                  <NoDataFound title='No Projects Yet'></NoDataFound>
                </TableCell>
              </TableRow>
            )}
            {sortedRowData.length !== 0 &&
              sortedRowData.map((row, i) => {
                return (
                  <Row
                    key={i}
                    logo={1}
                    {...props}
                    row={row}
                    getRowDetailDataFunc={getRowDetailDataFunc}
                  />
                )
              })}
          </TableBodyWrapper>
        </Table>
      )}
    </TableOuterWrapper>
  )
}

DataGridTable.propTypes = {
  columns: PropTypes.array,
  rows: PropTypes.array,
  loading: PropTypes.bool,
  loadingDetails: PropTypes.bool,
  sortingBy: PropTypes.string,
  getRowDetailData: PropTypes.func,
  logo: PropTypes.number,
}

export default DataGridTable
